import { useOrganizationStore } from '@/store/organization.store'

/**
 * Returns true when the current user is accessing the active organization
 * via an ExternalOrgRelationship (i.e. they are not a direct Member of the
 * host org). Used to hide member-only surfaces such as My Time, My Expenses,
 * My Tasks, and My Notes.
 */
export function useIsExternalUser(): boolean {
  return useOrganizationStore((state) => state.currentOrganization?.isExternalAccess === true)
}
